"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _actions = require("../actions");

var _immutable = require("immutable");

var _AnalyticsPeriod = _interopRequireDefault(require("hub-pickers-lib/constants/AnalyticsPeriod"));

var _handleActions;

var initialState = (0, _immutable.Map)({
  filter: '',
  analyticsPeriod: _AnalyticsPeriod.default.WEEKLY,
  analyticsPeriodLoading: true,
  hubsFailedToLoad: false
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.AccountsActionTypes.FILTER_ACCOUNTS, function (state, action) {
  return state.set('filter', action.payload.filter);
}), (0, _defineProperty2.default)(_handleActions, _actions.AccountsActionTypes.SET_ANALYTICS_PERIOD, function (state, action) {
  return state.set('analyticsPeriod', action.payload.analyticsPeriod);
}), (0, _defineProperty2.default)(_handleActions, _actions.AccountsActionTypes.GET_ANALYTICS_PERIOD_START, function (state) {
  return state.set('analyticsPeriodLoading', true);
}), (0, _defineProperty2.default)(_handleActions, _actions.AccountsActionTypes.GET_ANALYTICS_PERIOD_FINISH, function (state, action) {
  return state.merge({
    analyticsPeriodLoading: false,
    analyticsPeriod: action.payload.analyticsPeriod
  });
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;